import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

import {
  TypographyColor, TypographyFontFamily, TypographyFontSize
} from '@design-system/components/atoms/typography/entities/typography.types';
import { TagStatusSize, TagStatusType } from '@design-system/components/molecules/tag-status/entities/tag-status.types';
import { Icon, IconFillColor } from '@design-system/components/atoms/icon/entities/icon.types';
import { TypographyDsComponent } from '@design-system/components/atoms/typography/typography.component';
import { IconDsComponent } from '@design-system/components/atoms/icon/icon.component';

@Component({
  selector: 'app-ds-tag-status',
  templateUrl: './tag-status.component.html',
  styleUrls: ['./tag-status.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    TypographyDsComponent,
    IconDsComponent,
  ]
})
export class TagStatusDsComponent {

  @Input() size = TagStatusSize.XL;
  @Input() type = TagStatusType.Original;
  @Input() title: string;

  public readonly fontFamily = TypographyFontFamily;

  constructor() { }

  get icon(): Icon {
    switch (this.type) {
      case TagStatusType.Success:
        return Icon.Check;
      case TagStatusType.Processing:
        return Icon.Stop;
      case TagStatusType.Error:
        return Icon.Close;
      case TagStatusType.Cancelled:
        return Icon.Without;
      default:
        return null;
    }
  }

  get fontSize(): TypographyFontSize {
    switch (this.size) {
      case TagStatusSize.XL:
        return TypographyFontSize.MD;
      case TagStatusSize.LG:
        return TypographyFontSize.XS;
      case TagStatusSize.MD:
        return TypographyFontSize.XXS;
      default:
        return TypographyFontSize.XXXS;
    }
  }

  get fontColor(): TypographyColor {
    switch (this.type) {
      case TagStatusType.Success:
        return TypographyColor.Success;
      case TagStatusType.Processing:
        return TypographyColor.Warning;
      case TagStatusType.Error:
        return TypographyColor.Error;
      case TagStatusType.Cancelled:
        return TypographyColor.Secondary;
      default:
        return TypographyColor.PrimeBranding;
    }
  }

  get iconSize(): number {
    switch (this.size) {
      case TagStatusSize.XL:
        return 25;
      case TagStatusSize.LG:
      case TagStatusSize.MD:
        return 20;
      default:
        return 16;
    }
  }

  get iconColor(): IconFillColor {
    switch (this.type) {
      case TagStatusType.Success:
        return IconFillColor.Success;
      case TagStatusType.Processing:
        return IconFillColor.Warning;
      case TagStatusType.Error:
        return IconFillColor.Error;
      case TagStatusType.Cancelled:
        return IconFillColor.Secondary;
      default:
        return IconFillColor.PrimeBranding;
    }
  }

}
